import { Link as RouterLink } from 'react-router-dom';

import styled, { AppColorStrings } from '../../styles';
import { getColorFromTheme, getFontSizeFromTheme } from '../../utils/theme';

const TypographyBase = styled.p<TypoProps>(props => {
  const disabledColor = getColorFromTheme(props, 'disabledText');
  const color = props.color ? getColorFromTheme(props, props.color) : 'inherit';
  const display = props.display ? props.display : 'initial';
  return {
    alignItems: props.alignItems,
    color: props.disabled ? disabledColor : color,
    display: props.isBlock ? 'block' : display,
    fontSize: props.size || getFontSizeFromTheme(props),
    fontWeight: props.weight || 400,
    letterSpacing: 'normal',
    lineHeight: props.lineHeight || 'normal',
    margin: 0,
    marginBottom: props.noMargin ? 0 : '0.5em',
    opacity: props.opacity || 1,
    textAlign: props.align || 'inherit',
    textDecoration: props.decoration || 'initial',
  };
});

export const Title = styled(TypographyBase)(props => ({
  fontSize: props.size || 40,
  fontWeight: 600,
})).withComponent('h1');

export const Headline = styled(TypographyBase)(props => ({
  fontSize: props.size || 20,
  fontWeight: props.weight || 600,
  padding: props.padding || '',
  textAlign: props.align || 'inherit',
})).withComponent('h2');

export const Subtitle = styled(TypographyBase)(props => ({
  color: getColorFromTheme(props, 'warmGrey'),
  fontSize: props.size || 20,
  fontWeight: props.weight || 400,
})).withComponent('h2');

export const SubtitleDark = styled(TypographyBase)(props => ({
  fontSize: props.size || 20,
  fontWeight: props.weight || 400,
})).withComponent('h2');

export const P = TypographyBase;
export const A = styled(TypographyBase)({
  cursor: 'pointer',
}).withComponent('a');
export const Strong = styled(TypographyBase)({
  fontWeight: 600,
}).withComponent('strong');
export const Link = TypographyBase.withComponent(RouterLink);
export const Label = TypographyBase.withComponent('label');
export const Small = styled(TypographyBase)({
  fontSize: 11,
  lineHeight: '20px',
  opacity: 0.6,
});

interface TypoProps {
  align?: 'left' | 'center' | 'right';
  alignItems?: string;
  color?: AppColorStrings;
  decoration?: string;
  display?: string;
  size?: string | number;
  weight?: number;
  as?: string;
  disabled?: boolean;
  isBlock?: boolean;
  noMargin?: boolean;
  opacity?: number;
  padding?: string;
  lineHeight?: number | string;
}

export default TypographyBase;
